// AgentX API (backend apps/agentx; superusers only while AGENTX_ENABLED is on).
import API from './api';

const base = '/api/agentx';

const agentxService = {
  listSessions: () => API.get(`${base}/sessions/`),
  createSession: (title = '') => API.post(`${base}/sessions/`, { title }),
  getSession: (id) => API.get(`${base}/sessions/${id}/`),
  ask: (id, text) => API.post(`${base}/sessions/${id}/messages/`, { text }),
  getTurn: (turnId) => API.get(`${base}/turns/${turnId}/`),
  getSpend: () => API.get(`${base}/spend/`),
  checkCard: (body) => API.post(`${base}/card/`, body, { timeout: 120000 }),
  launch: (body) => API.post(`${base}/launch/`, body, { timeout: 120000 }),
};

export default agentxService;
